<template>
  <b-modal
    id="pre-reg-required-info-modal"
    ref="pre-reg-required-info-modal"
    body-class="p-10"
    centered
    title="Additional Information Needed"
    content-class="p-2"
    @hidden="resetModal"
    @show="openModal"
  >
    <b-overlay
      id="overlay-pre-reg-required-info-modal"
      :show="isLoading"
      variant="white"
      opacity="1"
      rounded="sm"
    >
      <div>
        <p v-if="userName" class="mb-3">To register {{ userName }} for this program, you need to complete the following form(s):</p>
        <p v-else class="mb-3">To register for this program, you need to complete the following form(s):</p>

        <ul v-if="unfilledForms.length">
          <li
            v-for="form in unfilledForms"
            :key="form.id"
            class="mb-1"
          >
            {{ form.name }}
            <span v-if="form.status !== 'not_started'" class="text-muted"> ({{ form.status }})</span>
          </li>
        </ul>

        <p v-else class="text-muted">All required forms are already completed.</p>
      </div>
    </b-overlay>


    <template #modal-footer>
      <div class="w-100 d-flex">
        <b-button
          v-if="requiredForms.length === 0"
          class="border border-primary"
          variant="outline-primary"
          @click="skipForNow"
        >
          Skip For Now
        </b-button>
        <b-button
          variant="primary"
          class="ml-auto"
          @click="goToPreRegForms"
        >
          Fill Out Forms
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

import { BModal, BButton, BOverlay, } from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BButton,
    BOverlay,
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      requiredForms: 'preRegistrationForm/getUnfilledRequiredForms',
      unfilledForms: 'preRegistrationForm/getUnfilledForms',
      userName: 'preRegistrationForm/getManageableUserName',
    }),
  },
  methods: {
    resetModal() {},
    openModal() {},
    goToPreRegForms() {
      this.$bvModal.hide('pre-reg-required-info-modal')
    },
    skipForNow() {
      this.$bvModal.hide('pre-reg-required-info-modal')
    },
  },
}
</script>

<style scoped>
</style>